import { ca } from '@cian/analytics';

import { NEW_OBJECTS_KEYS, TIndexableObject } from '../interfaces/village';
import { InfrastructureType } from '../store/map';
import { IVillageSchema, IRelatedVillageSchema } from '../types';

export const BASE_EVENT = {
  category: 'Card_KP',
  label: '',
  name: 'oldevent',
};

const ANALYTICS_OBJECT_TYPES: TIndexableObject = {
  [NEW_OBJECTS_KEYS.COTTAGE]: 'cottage',
  [NEW_OBJECTS_KEYS.TOWNHOUSE]: 'townhouse',
  [NEW_OBJECTS_KEYS.LOWRISEHOUSE]: 'mjk',
  [NEW_OBJECTS_KEYS.LANDPLOT]: 'uchastok',
};

const ANALYTICS_INFRASTRUCTURE_CATEGORY: { [key: number]: string } = {
  [InfrastructureType.Schools]: 'schools',
  [InfrastructureType.Kindergarden]: 'kindergardens',
  [InfrastructureType.Polyclinics]: 'polyclinics',
  [InfrastructureType.GroceryStores]: 'shops',
  [InfrastructureType.Cafes]: 'cafes',
};

export const gatherAnalyticsInfo = (village: IVillageSchema | IRelatedVillageSchema, builderId?: number) => ({
  brand: `${'builder' in village ? village.builder?.id : builderId}/developer_company`,
  category: 'sale/KP',
  id: village.id,
  name: `Коттеджный посёлок «${village.name}»`,
  quantity: 1,
});

export const trackPhotoTabClick = () => {
  ca('event', {
    ...BASE_EVENT,
    action: 'tab_photos_photo_block',
  });
};

export const trackVideoTabClick = () => {
  ca('event', {
    ...BASE_EVENT,
    action: 'tab_video_photo_block',
  });
};

export const trackGotoListingKpClick = (label: string) => {
  ca('event', {
    ...BASE_EVENT,
    action: 'goto_listingKP_blockKP',
    label,
  });
};

export const trackGotoListingDeveloperClick = (label: string) => {
  ca('event', {
    ...BASE_EVENT,
    action: 'goto_listingKP_blockdeveloper',
    label,
  });
};

export const trackGalleryFullScreenEnter = () => {
  ca('event', {
    ...BASE_EVENT,
    action: 'open_gallery',
    label: 'main',
  });
};

export const trackObjectFullScreenEnter = () => {
  ca('event', {
    ...BASE_EVENT,
    action: 'open_gallery',
    label: 'objects_type',
  });
};

export function trackObjectPhotoSlide() {
  ca('eventSite', {
    ...BASE_EVENT,
    action: 'slide_photo',
    label: 'objects_type_standart',
  });
}

export function trackObjectPhotoInFullScreenSlide() {
  ca('eventSite', {
    ...BASE_EVENT,
    action: 'slide_photo',
    label: 'objects_type_fullscreen',
  });
}

export const trackAnchorTabClick = (label: string) => {
  ca('event', {
    ...BASE_EVENT,
    action: 'click_tab',
    label,
  });
};

export const trackObjectTabClick = (objectType: string) => {
  ca('event', {
    ...BASE_EVENT,
    action: 'objects_type_click_tab',
    label: ANALYTICS_OBJECT_TYPES[objectType],
  });
};

export const trackObjectPriceLinkClick = () => {
  ca('event', {
    ...BASE_EVENT,
    action: 'goto_listing',
    label: 'Price',
  });
};

export const trackShowMap = () => {
  ca('event', {
    ...BASE_EVENT,
    action: 'show_map',
  });
};

export const trackMapInfrastructureClick = (infrastructure: InfrastructureType) => {
  ca('event', {
    ...BASE_EVENT,
    action: 'infrastructure',
    label: ANALYTICS_INFRASTRUCTURE_CATEGORY[infrastructure],
  });
};

export const trackShowFullInfoClick = (action: 'KP_info_open' | 'developer_info_open') => {
  ca('event', {
    ...BASE_EVENT,
    action,
  });
};

export const trackKpSiteClick = (label: string) => {
  ca('event', {
    ...BASE_EVENT,
    action: 'goto_KPsite',
    label,
  });
};

export const trackOpenFeedbackForm = () => {
  ca('event', {
    ...BASE_EVENT,
    action: 'show',
    category: 'KPDeveloperForm',
  });
};

export const trackCloseFeedbackForm = () => {
  ca('event', {
    ...BASE_EVENT,
    action: 'close',
    category: 'KPDeveloperForm',
  });
};

export const trackSubmitFeedbackForm = () => {
  ca('event', {
    ...BASE_EVENT,
    action: 'submit',
    category: 'KPDeveloperForm',
  });
};

export const trackOpenRoadsLink = () => {
  ca('event', {
    ...BASE_EVENT,
    action: 'goto_listingKP',
    label: 'highway_click',
    page: {
      pageType: 'CardKP',
    },
  });
};

export const trackOpenRailwayLink = () => {
  ca('event', {
    ...BASE_EVENT,
    action: 'goto_listingKP',
    label: 'railway_click',
    page: {
      pageType: 'CardKP',
    },
  });
};
